import React, { useEffect } from 'react';
import Header from './../components/Header';
import Sales from './../components/Sales';
import Partners from './../components/Partners';

const ForCompaniesPage = () => {
  useEffect(() => {
    window.scrollTo(-100, 0);
  }, []); // The empty array ensures this effect runs only once after the initial render

  return (
    <div id="root">
      <div className="main-content">
        <Header />
        <Sales />
      </div>
      <Partners />
    </div>
  );
}

export default ForCompaniesPage;
